import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Prompt } from 'react-router-dom';

class UnsavedChangesPrompt extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    }

    static propTypes = {
        message: PropTypes.string
    };

    static defaultProps = {
        message: 'You have unsaved changes. Leave page?'
    };

    _wasPromptShown = false;

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);

        this.unlisten = this.props.history.listen(() => {
            this._wasPromptShown = true;
        });
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);

        this.unlisten();
    }

    handleBeforeUnload(event) {
        if (!this._wasPromptShown) {
            event.preventDefault();
            event.returnValue = true;
        }
    }

    render() {
        return <Prompt message={this.props.message} />;
    }
}

export default withRouter(UnsavedChangesPrompt);
